export enum CourtArea {
  TOP_OF_KEY = 'TOP_OF_KEY',
  LEFT_WING = 'LEFT_WING',
  RIGHT_WING = 'RIGHT_WING',
  LEFT_CORNER = 'LEFT_CORNER',
  RIGHT_CORNER = 'RIGHT_CORNER',
  LEFT_SHORT_CORNER = 'LEFT_SHORT_CORNER',
  RIGHT_SHORT_CORNER = 'RIGHT_SHORT_CORNER',
  MID_RANGE_CENTER = 'MID_RANGE_CENTER',
  MID_RANGE_LEFT = 'MID_RANGE_LEFT',
  MID_RANGE_RIGHT = 'MID_RANGE_RIGHT',
  PAINT = 'PAINT',
}
